module.exports = __webpack_public_path__ + "static/img/2.9660e2fe.png";